import type { QueryClient } from "@tanstack/react-query";
import { UserProfileApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchCommunicationSettings(
  id: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error(
      "Access token is required for prefetching communication settings",
    );
  }

  const service = createAuthenticatedApi(UserProfileApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.CommunicationSettings, id],
    queryFn: () => service.apiUserProfileIdSettingsGet({ id }),
  });

  return queryClient;
}
